import React from 'react';
import ReactDOM from 'react-dom';
import { CustomWindow } from './legislationCodeSection.types';
import { snakeToCamel } from '../../../caseUtils';
import { LegislationCodeApp } from '../code/LegislationCodeApp';

declare let window: CustomWindow;

const target = document.querySelector(`[data-react=doctrine-react]`);
if (target) {
  ReactDOM.render(
    <LegislationCodeApp
      codeInfos={snakeToCamel(window.legislation_code_section_infos)}
      isCode={false}
    />,
    target,
  );
} else {
  // eslint-disable-next-line no-console
  console.log(`doctrine-react is not visible in the DOM`);
}
